/* unplugin-vue-components disabled */import { render } from "./newDetail.vue?vue&type=template&id=aad41896&scoped=true"
import script from "./newDetail.vue?vue&type=script&lang=js"
export * from "./newDetail.vue?vue&type=script&lang=js"

import "./newDetail.vue?vue&type=style&index=0&id=aad41896&lang=less&scoped=true"

import exportComponent from "/Users/yfy/work/work/cms-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aad41896"]])

export default __exports__